// Beta-feature gates driven by deploy environment.
//
// VITE_ENVIRONMENT is set by .github/workflows/deploy-*.yml at build time:
//   deploy-dev.yml  -> 'dev'
//   deploy-test.yml -> 'test'
//   deploy-uat.yml  -> 'uat'
//   deploy-prod.yml -> 'production'
//
// HIDE_BETA_FEATURES hides Hindi i18n and voice in/out controls on dev only,
// while leaving the underlying code (locales, hooks, AWS clients) intact for
// easy re-enable. To restore on dev, delete this flag's usages or change the
// condition.

export const HIDE_BETA_FEATURES =
  import.meta.env.VITE_ENVIRONMENT === 'dev';

// True on environments that are part of the closed beta. Surfaces a "BETA"
// pill in the headers and a short tester-context line on the welcome screen.
// Kept separate from HIDE_BETA_FEATURES so the two can be decoupled later
// (e.g. unhide voice on dev without losing the beta badge).
export const BETA_MODE =
  import.meta.env.VITE_ENVIRONMENT === 'dev';

// Demo Mode (scripted, client-side answers for external presentations) is
// offered only on dev. Gated the same way as the beta flags above so the
// environments stay identical everywhere else. See contexts/DemoModeContext.tsx.
export const DEMO_MODE_AVAILABLE =
  import.meta.env.VITE_ENVIRONMENT === 'dev';
